

exports.__esModule = true;
exports.$forbiddenHandler = $forbiddenHandler;
exports.$exceptionHandler = $exceptionHandler;

var _uiRouter = require('uiRouter');

var _angular = require('angular');

var _logger = require('xo-beaver/dist/logger');

var _index = require('xo-models/src/auth/index');

var _squid = require('squid');

var _fallback = require('./fallback');

var _contingency = require('./contingency');

var _thirdPartyInfo = require('xo-third-party-components/src/thirdParty-info');

// ui-router rejects $state.go promises if the navigation is cancelled.
var uiRouterTransitionErrors = ['transition prevented', 'transition aborted', 'transition superseded'];

function canBeSafelyIgnored(err) {
    return err instanceof _squid.$ShortCircuit || uiRouterTransitionErrors.includes(err.message);
}

function constructEventName(toState, fromState) {
    var from = fromState.name.replace(/\./g, '_') || 'start';
    var to = toState.name.replace(/\./g, '_') || 'end';

    return 'state_change_' + from + '_to_' + to;
}

function constructErrorPayload(_ref) {
    var err = _ref.err,
        message = _ref.message,
        cause = _ref.cause;

    var payload = {
        error: err.stack || err.toString(),
        message: message || err.message,
        cause: cause && cause.toString(),
        state: _uiRouter.$state.current.name,
        url: window.location.toString()
    };

    angular.extend(payload, err.payload || {});

    return payload;
}

function $forbiddenHandler(err) {
    _logger.$logger.warn('forbidden_handler');
    if (!err.transient) {
        _index.$AuthModel.instance().invalidate();

        if (_angular.$rootScope.paymentComplete) {
            throw new _squid.$Contingency('PAYMENT_ALREADY_DONE');
        }

        _uiRouter.$state.go('checkout.login');
    }
}

function handleThirdPartyErrors(err, cause) {
    var errType = (err && err.constructor && err.constructor.name || 'error').toLowerCase();
    var experience = _thirdPartyInfo.thirdPartyExperience.getExperience(_angular.$rootScope.token);
    var errName = 'ui_' + experience.toLowerCase() + '_' + errType;
    var payload = constructErrorPayload({ err: err, cause: cause });

    _logger.$logger.error(errName, payload);
    _index.$AuthModel.instance().logout();
    _thirdPartyInfo.thirdPartyExperience.resetThirdPartyExperience();

    if (experience === 'VENMO_EXPERIENCE') {
        _uiRouter.$state.go('checkout.login', { venmoError: true });
    }

    if (experience === 'BAIDU_EXPERIENCE') {
        _uiRouter.$state.go('checkout.login', { baiduError: true });
    }
}

function isThirdPartyFlow() {
    return _thirdPartyInfo.thirdPartyExperience.isThirdPartyExperience(_angular.$rootScope.token);
}

var ERROR_HANDLERS = [{
    type: _squid.$FallbackError,
    handler: _fallback.$fallbackErrorHandler
}, {
    type: _squid.$Contingency,
    handler: _contingency.$contingencyHandler
}, {
    type: _squid.$Forbidden,
    handler: $forbiddenHandler
}];

function $exceptionHandler(err, cause) {
    if (canBeSafelyIgnored(err)) {
        if (err.message) {
            _logger.$logger.info(err.message);
        }
        return true;
    }

    if (_angular.$rootScope.ERROR_STATE) {
        if (_angular.$rootScope.ERROR_PREVENTED) {
            throw err;
        }

        return;
    }

    if (isThirdPartyFlow()) {
        if (err instanceof _squid.$Forbidden) {
            // forbidden errors should take you to login page
            return $forbiddenHandler(err);
        } else {
            return handleThirdPartyErrors(err, cause);
        }
    }

    var handled = _squid.$util.some(ERROR_HANDLERS, function (errorHandler) {
        if (err instanceof errorHandler.type) {
            errorHandler.handler(err);

            return true;
        }
    });

    if (handled) {
        return;
    } else if (!err.transient) {
        _angular.$rootScope.ERROR_STATE = err;
    }

    var errType = (err.constructor.name || 'error').toLowerCase();
    var errName = 'ui_unhandled_' + errType;
    var errMsg = err.message || '';

    if (errMsg.indexOf('infdig') > -1) {
        errName = 'infinite_digest';
    } else if (errMsg.indexOf('inprog') > -1) {
        errName = 'digest_inprog';
    } else if (errMsg.indexOf('badparse') > -1) {
        errName = 'sanitize_badparse';
    } else if (errMsg.match(/^[\w_]+$/)) {
        errName = 'ui_unhandled_' + errMsg;
    }

    if (['ui_unhandled_error', 'ui_unhandled_typeerror'].indexOf(errName) > -1) {
        if (err.stack && err.stack.indexOf('framework') > -1 && err.stack.indexOf('main.js') === -1) {
            errName = 'ui_unhandled_framework_error';
        }
    }

    if (err.transient) {
        errName += '_transient';
    }

    var payload = constructErrorPayload({ err: err, message: errMsg, cause: cause });

    _logger.$logger.error(errName, payload);
    _logger.$logger.error('build_' + _squid.$meta.buildId + '_' + errName, payload); // release vs live traffic separation

    // emit the error object for subscribers like xo-tracking
    var event = _angular.$rootScope.$emit('unhandled_error', {
        err: err,
        route: (_uiRouter.$state || {}).current,
        message: payload.error,
        code: payload.cause
    });

    if (event.defaultPrevented) {
        _angular.$rootScope.ERROR_PREVENTED = true;
        throw err;
    } else if (!err.transient) {
        return (0, _fallback.$fallbackErrorHandler)(new _squid.$FallbackError({
            reason: errName
        }));
    }
}

_angular.$rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, err) {
    // Set prevent default to avoid angular UI router to keep looping back to same state
    event.preventDefault();
    $exceptionHandler(err, constructEventName(toState, fromState));
});

_angular.$rootScope.$on('$windowError', function (event, details) {
    _logger.$logger.error('window_error', details, {
        unique: true
    });
});

angular.value("$forbiddenHandler", $forbiddenHandler);
angular.value("$exceptionHandlerLazy", $exceptionHandler);
_uiRouter.$state;

_angular.$rootScope;

_logger.$logger;

_index.$AuthModel;

_squid.$util;

_squid.$FallbackError;

_squid.$Forbidden;

_squid.$ShortCircuit;

_squid.$Contingency;

_squid.$meta;

_fallback.$fallbackErrorHandler;

_contingency.$contingencyHandler;

_thirdPartyInfo.thirdPartyExperience;


//////////////////
// WEBPACK FOOTER
// ./js/lib/error.js
// module id = ./js/lib/error.js
// module chunks = main-code-split